// src/components/storefronts/AboutTabContent.js

import React from 'react';
import ExpandableSection from '../ui/1-molecules/ExpandableSection/ExpandableSection';
import Awards from '../ui/2-organisms/Awards/Awards';
import VideoSection from '../ui/2-organisms/VideoSection/VideoSection';
import ImageGallery from '../ui/2-organisms/ImageGallery/ImageGallery';
import RecommendedRings from '../ui/2-organisms/RecommendedRings/RecommendedRings';
import styles from './AboutTabContent.module.css';

const AboutTabContent = ({ jeweller, topRings, onRingClick, previewMode = false }) => {
  const firstName = jeweller?.firstName || 'the founder';

  // Create the new title with the text and the filled Hero Icons badge
  const ethicalChampionTitle = (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--spacing-xxs)' }}>
      Ethical Jeweller
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        style={{ width: '1.25em', height: '1.25em' }}
        aria-hidden="true"
      >
        {/* Path for the filled blue badge */}
        <path
          fill="var(--Action-Primary, #005A9C)"
          d="M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
        />
        {/* Path for the white checkmark */}
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12.75 11.25 15 15 9.75"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth={2}
        />
      </svg>
    </span>
  );

  return (
    <div className={styles.wrapper}>
      {/* NEW: Recommended Rings Section */}
      <RecommendedRings 
        topRings={topRings}
        onRingClick={onRingClick}
      />

      {/* About Company Section */}
      <ExpandableSection
        title={jeweller?.companyName ? `${jeweller.companyName}` : 'About Jeweller'}
        content={jeweller?.introParagraph}
        maxLines={7}
      />

      {/* Video Section */}
      <VideoSection
        videoUrl={jeweller?.showcaseVideo}
        thumbnailUrl={jeweller?.video?.thumbnailUrl}
        title={`${jeweller?.companyName || 'Jeweller'} showcase video`}
        disablePlay={previewMode}
      />

      {/* Bio Section - Get to know the founder */}
      <ExpandableSection
        title={`Get to know ${firstName}`}
        content={jeweller?.bio}
        maxLines={7}
      />

      {/* Gallery Section */}
      <ImageGallery
        images={jeweller?.galleryImages}
        title="Gallery"
      />

      {/* Awards Section */}
      <Awards
        awards={jeweller?.awards}
        jewellerId={jeweller?.id}
        sectionTitle="Awards & Recognition"
        disableNavigation={previewMode}
      />

      {/* Ethical Practices Section */}
      {jeweller?.ethicalStatement && (
        <ExpandableSection
          title={ethicalChampionTitle}
          content={jeweller?.ethicalStatement}
          maxLines={7}
        />
      )}
    </div>
  );
};

export default AboutTabContent;
